import { useState, useTransition } from "react"
import { ChatListItem } from "./chat-list-item"
import { ChatFilter } from "./chat-filter"
import { useChats } from "../hooks/use-chats"

export function ChatList() {
  const [filter, setFilter] = useState("")
  const [isPending, startTransition] = useTransition()
  const { data } = useChats(filter)

  const handleFilterChange = (value: string) => {
    startTransition(() => setFilter(value))
  }

  return (
    <div className="bg-white flex flex-col">
      <ChatFilter value={filter} onChange={handleFilterChange} isPending={isPending} />

      <div className={`flex flex-col${isPending ? " opacity-50 transition-opacity" : " transition-opacity"}`}>
        {data.items.map((chat) => (
          <ChatListItem key={chat.id} chat={chat} />
        ))}
      </div>
    </div>
  )
}
